var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unit-size-estimate-indicator-wrapper"},[(_vm.unit_data)?_c('unit-size-estimate-indicator',{attrs:{"unit":_vm.unit_data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }